/**
 * Trigger Type Badge Component
 * Displays whether a job was triggered by a schedule or manually via API
 */

import { Clock, User } from 'lucide-react'

interface TriggerTypeBadgeProps {
  triggerType: string
}

export function TriggerTypeBadge({ triggerType }: TriggerTypeBadgeProps) {
  const upper = triggerType?.toUpperCase()

  if (upper === 'MANUAL_API') {
    return (
      <span className="inline-flex items-center gap-1 rounded-full bg-blue-50 px-2 py-0.5 text-xs font-medium text-blue-700">
        <User className="h-3 w-3" />
        Manual
      </span>
    )
  }

  return (
    <span className="inline-flex items-center gap-1 rounded-full bg-gray-100 px-2 py-0.5 text-xs font-medium text-gray-600">
      <Clock className="h-3 w-3" />
      Scheduled
    </span>
  )
}
